import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../../services/website-theme.service';
import { Router } from '@angular/router';
import { LocationStrategy } from "@angular/common";
import { SharedHttp } from "../../../../services/http-client.service";
/**
 * Disable Mfa Modal Component
 */
let DisableMfaModalComponent = class DisableMfaModalComponent {
    constructor(sanitizer, router, httpClient, location, themeService) {
        this.sanitizer = sanitizer;
        this.router = router;
        this.httpClient = httpClient;
        this.location = location;
        this.themeService = themeService;
        this.secondColor = '';
        this.accentColor = '';
        this.successColor = '';
        this.inputBackColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.errorColor = '';
        this.hasWallet = false;
        this.proceeded = false;
        this.validCode = true;
        this.disableButton = true;
        this.isMfaRequired = true;
        this.recoveryCode = '';
        this.submitted = false;
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
        this.user = JSON.parse(localStorage.getItem('user'));
        if (typeof this.data !== 'undefined' && this.data != null) {
            this.hasWallet = this.data.hasWallet;
        }
    }
    close() {
        this.modal.destroy();
    }
    goToDisableMfa() {
        this.proceeded = true;
        setTimeout(() => {
            document.getElementById('mfa').focus();
        }, 100);
    }
    checkValidation(event) {
        if (this.isMfaRequired) {
            this.disableButton = !this.mfaCode || this.mfaCode.length !== 6;
        }
        else {
            this.disableButton = this.recoveryCode.length !== 19;
        }
        if (event.keyCode === 13 && !this.disableButton) {
            this.disableMfa();
        }
    }
    disableMfa() {
        this.submitted = true;
        this.validCode = true;
        this.httpClient.post('mfa/cancelmfa', { id: this.user.id, code: this.isMfaRequired ? this.mfaCode : this.recoveryCode }).subscribe((data) => {
            if (data['canceled']) {
                this.close();
            }
            else {
                this.validCode = false;
                this.submitted = false;
            }
        });
    }
    toggleMfaRecoveryCode() {
        this.isMfaRequired = !this.isMfaRequired;
        this.validCode = true;
        this.checkValidation(Event.NONE);
        setTimeout(() => {
            document.getElementById(this.isMfaRequired ? 'mfa' : 'recoveryCode').focus();
        }, 100);
    }
};
DisableMfaModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: Router },
    { type: SharedHttp },
    { type: LocationStrategy },
    { type: WebsiteThemeService }
];
DisableMfaModalComponent = __decorate([
    Component({
        selector: 'ecd-disable-mfa-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./disable-mfa-modal.component.html")).default
    })
], DisableMfaModalComponent);
export { DisableMfaModalComponent };
